import {
    createLoaderUtils,
    initializeFiltersFromDOM,
    buildFilterUrl,
    createSearchHandler,
    createSortHandler
} from './ajax-filters-shared.js';

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.archive-filters');
    if (!section) return;

    const archivePostType = section.dataset.postType;

    let filters = {
        type: null,
        topic: null,
        date: null,
        search: '',
        sort: 'recent',
    };

    initializeFiltersFromDOM(section, filters);

    // Resources archive: full page reload for all filters (pagination is server-rendered).
    if (archivePostType === 'resources') {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('date')) {
            filters.date = urlParams.get('date');
        }

        section.querySelectorAll('.custom-select__option').forEach((filter) => {
            filter.addEventListener('click', function (e) {
                const value = e.target.dataset.value;
                const filterKey = e.target.dataset.filter;

                if (filterKey === 'type' || filterKey === 'topic') {
                    filters[filterKey] = value === 'all' ? null : value;
                    window.location.href = buildFilterUrl(filters, archivePostType);
                    return;
                }

                if (filterKey === 'date') {
                    filters.date = value === 'all' ? null : value;
                    const url = new URL(window.location.href);

                    if (filters.date) {
                        url.searchParams.set('date', filters.date);
                    } else {
                        url.searchParams.delete('date');
                    }

                    url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
                    window.location.href = url.pathname + url.search;
                }
            });
        });

        return;
    }

    const archiveTax = section.dataset.taxonomy;
    const archiveTerm = section.dataset.term;

    const resultContainer = section.querySelector('.archive-results');
    const paginationWrapper = section.querySelector('.load-more-wrapper');
    const loadMoreBtn = section.querySelector('.load-more-archives');
    const countLabel = section.querySelector('.archive-total-count');
    const loader = section.querySelector('.loader');
    const searchInput = section.querySelector('.resource-search');
    const clearBtn = section.querySelector('.clear-search');
    const popularBtn = section.querySelector('.most-popular');
    const recentBtn = section.querySelector('.most-recent');

    let currentPage = 2;

    const loaderUtils = createLoaderUtils(loader);

    let isFetching = false;
    function fetchResources() {
        if (isFetching) return;
        isFetching = true;

        loaderUtils.show();

        const status = document.getElementById('archive-search-status');
        if (status) status.textContent = 'Loading results...';

        const data = new URLSearchParams({
            action: 'filter_archive',
            page: currentPage,

            type: filters.type || '',
            topic: filters.topic || '',
            date: filters.date || '',
            search: filters.search || '',
            sort: filters.sort || '',

            post_type: archivePostType || '',
            archive_tax: archiveTax,
            archive_term: archiveTerm,
        });

        fetch(ajax.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data.toString(),
        })
            .then((res) => res.json())
            .then((response) => {
                const data = response.data;

                if (!data.html || data.html.trim() === '') {
                    if (currentPage === 1) {
                        resultContainer.innerHTML = '';
                        if (countLabel) countLabel.innerHTML = 'No results found';
                    }
                    if (paginationWrapper) paginationWrapper.classList.add('hidden');
                    if (loadMoreBtn) loadMoreBtn.classList.add('hidden');
                    if (status) status.textContent = 'No results found';
                    return;
                }

                if (currentPage === 1) {
                    resultContainer.innerHTML = data.html;
                } else {
                    resultContainer.insertAdjacentHTML('beforeend', data.html);
                }

                if (countLabel) countLabel.classList.remove('hidden');

                const totalPages = data.total_pages;

                if (totalPages > currentPage) {
                    if (paginationWrapper) paginationWrapper.classList.remove('hidden');
                    if (loadMoreBtn) loadMoreBtn.classList.remove('hidden');
                } else {
                    if (paginationWrapper) paginationWrapper.classList.add('hidden');
                    if (loadMoreBtn) loadMoreBtn.classList.add('hidden');
                }

                currentPage++;
            })
            .catch((error) => {
                console.error('Error fetching resources:', error);
                if (status) status.textContent = 'An error occurred while loading results';
            })
            .finally(() => {
                loaderUtils.hide();
                isFetching = false;
            });
    }

    section.querySelectorAll('.custom-select__option').forEach((filter) => {
        filter.addEventListener('click', function (e) {
            const value = e.target.dataset.value;
            const filterKey = e.target.dataset.filter;

            if (filterKey === 'type' || filterKey === 'topic') {
                filters[filterKey] = value === 'all' ? null : value;
                window.location.href = buildFilterUrl(filters, archivePostType);
                return;
            }

            filters[filterKey] = value === 'all' ? null : value;

            currentPage = 1;
            resultContainer.innerHTML = '';
            if (countLabel) countLabel.innerHTML = '';

            if (loadMoreBtn) loadMoreBtn.classList.add('hidden');

            fetchResources();
        });
    });

    createSearchHandler({
        searchInput,
        clearBtn,
        filters,
        onSearch: () => {
            currentPage = 1;
            resultContainer.innerHTML = '';
            if (countLabel) countLabel.innerHTML = '';
            fetchResources();
        },
    });

    createSortHandler({
        popularBtn,
        recentBtn,
        filters,
        onSort: () => {
            currentPage = 1;
            resultContainer.innerHTML = '';
            if (countLabel) countLabel.innerHTML = '';
            if (loadMoreBtn) loadMoreBtn.classList.add('hidden');
            fetchResources();
        },
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            fetchResources();
        });
    }
});
